import EvStationIcon from '@mui/icons-material/EvStation'
import GavelIcon from '@mui/icons-material/Gavel'
import RateReviewIcon from '@mui/icons-material/RateReview'
import ScheduleIcon from '@mui/icons-material/Schedule'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import CardWithIcon from 'src/components/common/CardWithIcon'
import Page from 'src/components/Page'
import {
  ROUTE_I_MEMORY,
  ROUTE_I_REMEMBER,
  ROUTE_I_REMEMBER_SRS,
  ROUTE_LETTER_HAMMER,
  ROUTE_PRACTICE_SENTENCE_REVIEW,
} from 'src/resources/routes'

const Workouts = () => {
  const { t } = useTranslation(['workoutPages'])

  return (
    <Page title={t('workouts')} isPadding>
      <Typography mb="20px" textAlign="center" variant="h5" component="h2">
        {t('workouts')}
      </Typography>

      <Box mx={{ lg: '0', xs: '15px' }} display="flex" flexWrap="wrap" gap={2}>
        <CardWithIcon
          restProps={{ component: NavLink, to: ROUTE_I_REMEMBER_SRS }}
          cardColor="primary.main"
          iconColor="primary.light"
          textColor="primary.contrastText"
          title={t('srs_title')}
          icon={ScheduleIcon}
        />
        <CardWithIcon
          restProps={{
            component: NavLink,
            to: ROUTE_PRACTICE_SENTENCE_REVIEW,
          }}
          cardColor="secondary.main"
          iconColor="secondary.light"
          textColor="secondary.contrastText"
          title={t('practice_review_title')}
          icon={RateReviewIcon}
        />
        <CardWithIcon
          restProps={{ component: NavLink, to: ROUTE_I_REMEMBER }}
          cardColor="#8936b3"
          iconColor="#f0d3ff"
          textColor="#f0d3ff"
          title="iRemember"
          icon={EvStationIcon}
        />

        <CardWithIcon
          restProps={{ component: NavLink, to: ROUTE_I_MEMORY }}
          cardColor="#e1a6ff"
          iconColor="#ffffff"
          textColor="#ffffff"
          title="iMemory"
          icon={ViewModuleIcon}
        />
        <CardWithIcon
          restProps={{ component: NavLink, to: ROUTE_LETTER_HAMMER }}
          cardColor="#f0d3ff"
          iconColor="#8936b3"
          textColor="#8936b3"
          title="Letter Hammer"
          icon={GavelIcon}
        />
        {/* Next card color #ff4dff */}
      </Box>
    </Page>
  )
}

export default Workouts
